const animate = function() {

  const sections = []
  Object.entries(window.storySettings).forEach(([key, value]) => {
    const section = document.querySelector(value.id);
    sections.push(section);
    const top = section.offsetTop;
    const bottom = section.getBoundingClientRect().bottom;
    const animTriggerThreshold = section.getBoundingClientRect().height * 0.3;
    window.storySettings[key].bottom = bottom;
    window.storySettings[key].top = top;
    window.storySettings[key].animTriggerThreshold = animTriggerThreshold;
  })

  firstAnimation()

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.3
  }

  sections.forEach(section => {
    const observer = new IntersectionObserver((e) => {
      if (e[0].isIntersecting) animateImage(section)
    }, options)
    observer.observe(section)
  })
}


const removePosters = () => {
  const videos = document.querySelectorAll('iframe.story-year-video')
  if (!videos) return;
  videos.forEach(v => {
    const player = new Vimeo.Player(v);
    player.on('play', () => {
      v.closest('.image_wrapper').style.backgroundImage = 'none';
    });
  })
}

const animateImage = function(section) {
  const components = section.querySelectorAll(`.animated-component`);
  components.forEach((component) => {
    component.classList.add('animated')
  })
}


const firstAnimation = function() {
  const currentPosition = window.pageYOffset;
  Object.entries(window.storySettings).forEach(([key, value]) => {
    if(window.storySettings[key].top < currentPosition) {
      document.querySelectorAll(`#shopify-section-${key} .animated-component`).forEach(c => {
        c.classList.add('animated')
      })
    }
  })
}


const init = function() {
  animate();
  removePosters()
}

export default init;